export const CUSTOMER_RECEIPT_STATUS_TO_TEXT = {
  NEW: 'Mới',
  PROCESSING: 'Đang xử lý',
  PENDING: 'Chờ xử lý',
  FAILED: 'Thất bại',
  SUCCESS: 'Thành công',
  CANCELED: 'Đã hủy'
}

export const PAYMENT_TYPE = {
  ATM_BANK: 1,
  MOMO: 2,
  GTEL_PAY: 3,
  VNPAY: 4,
  ZALOPAY: 5,
  VIETTEL_PAY: 6,
  TA_MOVE: 7,
  SEPAY: 8,
  VIETTEL_MONEY: 9,
  SHOPEEPAY: 10,
  BAOKIM: 11,
  KIMNGAN: 12,
  VNPAY_INAPP: 13,
  GTELPAY_INAPP: 14,
  VIETTEL_MONEY_GATEWAY: 15
}

export const PAYMENT_TYPE_CODE = {
  ATM_BANK: 'ATM_BANK',
  MOMO: 'MOMO',
  GTEL_PAY: 'GTELPAY',
  VNPAY: 'VNPAY',
  VNPAYAPP_INAPP: 'VNPAYAPP_INAPP',
  ZALOPAY: 'ZALOPAY',
  VIETTEL_PAY: 'VIETTEL_PAY',
  TA_MOVE: 'TA_MOVE',
  SEPAY: 'SEPAY',
  SHOPEEPAY: 'SHOPEEPAY',
  BAOKIM: 'BAOKIM',
  KIMNGAN: 'KIMNGAN',
  BIDV_INAPP: 'BIDV_INAPP'
}

export const VEHICLE_TYPE = {
  CAR: 1,
  OTHER: 10,
  RO_MOOC: 20,
  MOTOBIKE: 30,
  ELECTRIC_MOTORBIKE: 40
}

